import { render, staticRenderFns } from "./BrowseForm.vue?vue&type=template&id=489c93a6&scoped=true"
import script from "./BrowseForm.vue?vue&type=script&lang=js"
export * from "./BrowseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c93a6",
  null
  
)

export default component.exports